import { render, staticRenderFns } from "./TransferStart.vue?vue&type=template&id=5bec09e6&scoped=true&"
import script from "./TransferStart.vue?vue&type=script&lang=js&"
export * from "./TransferStart.vue?vue&type=script&lang=js&"
import style0 from "./TransferStart.vue?vue&type=style&index=0&id=5bec09e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec09e6",
  null
  
)

export default component.exports